var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdtLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Flat Color"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Tether (USDT)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#59af99",
    opacity: 1,
    "data-original": "#59af99",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M110.38 87.69V75.88h26.87V57.25H62.68v18.63h26.94v11.81c-22.57 1.09-39.51 5.62-39.51 11s16.92 9.93 39.51 11v39h20.76v-39c22.57-1.08 39.51-5.61 39.51-11s-16.89-9.91-39.51-11zM100 106.25c-24.44 0-44.25-3.78-44.25-8.33 0-3.91 14.43-7.2 33.85-8.08v13.34c3.34.15 6.81.24 10.38.24s7.06-.09 10.38-.24V89.84c19.42.88 33.85 4.17 33.85 8.08.04 4.6-19.77 8.33-44.21 8.33z",
    opacity: 1,
    "data-original": "#ffffff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtLogo);
export default __webpack_public_path__ + "static/media/usdt-logo.a43398b1810bdb569ecc6f73dd8c0583.svg";
export { ForwardRef as ReactComponent };